import {isFinite, flow, every} from 'lodash/fp'
import React, {Component} from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import {replaceAt, zip} from '../../utils'

import Button from '../../components/Button'
import Question from '../../components/Question'
import Scores from '../../components/Scores'

import './styles.css'

const validators = {
  button: answer => answer !== undefined && answer !== null,
  number: answer => every(flow(parseFloat, isFinite))(answer),
  radio: answer => answer !== undefined && answer !== null,
  zip: answer => zip.getState(answer) !== undefined && answer !== null,
}

class Questionnaire extends Component {
  state = {
    progress: 0,
    direction: 'slide',
  }

  componentWillMount() {
    this.setState({progress: this.props.defaultProgress || 0}) 
  }

  onQuestionAnswered = answer => {
    const {questions, answers, onAnswersChange} = this.props
    const {progress} = this.state
    const question = questions[progress]
    onAnswersChange(replaceAt(answers, progress, answer))
    
    if (question.type === 'radio' || question.type === 'button') {
      this.nextQuestion()
    }
  }

  nextQuestion = () => {
    const {questions, onNavigate} = this.props
    const {progress} = this.state
    const nextProgress = Math.min(progress + 1, questions.length)
    this.setState({
      direction: 'slide',
      progress: nextProgress,
    })
    onNavigate(nextProgress)
  }

  prevQuestion = () => {
    const {onNavigate} = this.props
    const {progress} = this.state
    const nextProgress = Math.max(progress - 1, 0)
    this.setState({
      direction: 'slide-reverse',
      progress: nextProgress,
    })
    onNavigate(nextProgress)
  }

  render() {
    const {questions, answers, emissions, onFinished, onNonUS} = this.props
    const {progress, direction} = this.state
    const question = questions[progress]
    const answer = answers[progress]
    const answerIsValid = validators[question.type](answer) &&
      (question.validator ? question.validator(answer) : true)

    return (
      <div className="questionnaire">
        <Scores
          progress={progress}
          questions={questions}
          emissions={emissions}
        />
        <div className="scroller">
          <ReactCSSTransitionGroup
            component='div'
            transitionName={`questionnaire-${direction}`}
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            <div className="questionnaire-carousel" key={progress}>
              <Question
                question={question}
                answer={answer}
                onChange={this.onQuestionAnswered}
              />
              <div className="questionnaire-navigation">
                { progress > 0 &&
                  <div className="questionnaire-back">
                    <Button borderless onClick={this.prevQuestion}>
                      <i className="fa fa-angle-double-left questionnaire-back-caret" />
                      Go Back
                    </Button>
                  </div>
                }
                { progress === 0 && !answerIsValid &&
                    <div className="questionnaire-forwards">
                      <Button borderless onClick={onNonUS}>
                        Not in the U.S.?
                        <i className="fa fa-angle-double-right questionnaire-forwards-caret" />
                      </Button>
                    </div>
                }
                { (progress < questions.length - 1) && answerIsValid &&
                    <div className="questionnaire-forwards">
                      <Button onClick={this.nextQuestion}>
                        Next
                        <i className="fa fa-angle-double-right questionnaire-forwards-caret" />
                      </Button>
                    </div>
                }
                { (progress === questions.length - 1) && answerIsValid &&
                    <div className="questionnaire-forwards">
                      <Button onClick={onFinished}>Finish</Button>
                    </div>
                }
              </div>
            </div>
          </ReactCSSTransitionGroup>
        </div>
      </div>
    )
  }
}

export default Questionnaire



// WEBPACK FOOTER //
// ./src/apps/Questionnaire/index.js